module.exports = __webpack_public_path__ + "img/Noctiluca-2.531231db.png";